import React, { forwardRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import DarkLogo from 'assets/images/dark-logo.png';

interface PrintComponentProps {
  link: string;
  tableNumber: string;
}

const QrCodePrint = forwardRef<HTMLDivElement, PrintComponentProps>(
  ({ link, tableNumber }, ref) => {
    return (
      <div ref={ref} className='grid place-items-center mt-[100px]'>
        <h4 className='font-medium text-[34px] mb-4'>Table {tableNumber}</h4>
        <div className='relative px-[8px] py-[12px] border-[6px] border-black'>
          <img
            src={DarkLogo}
            width={45}
            height={45}
            className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-2'
          />
          <QRCodeSVG width={260} height={250} value={link} />
        </div>
      </div>
    );
  }
);

QrCodePrint.displayName = 'QrCodePrint';

export default QrCodePrint;
